import React from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {useSelector} from 'react-redux';
import {Color, globalFontStyle} from '../assets';
import Width from '../assets/Width';
import FastImage from "../common/FastImage";
import {event_about} from "../utils/images";
import FormTextLabel from "./FormTextLabel";
import {globalConfigurableData} from "../utils/globalConstant";

const FAQ = ({faqtype = 'wallet'}) => {
  const faqData = useSelector(({utilReducer}) => utilReducer?.faqsData);
  const data = faqData && faqData[faqtype] ? faqData[faqtype] : null;
  return (
      <View
          style={{ marginTop: 4, paddingBottom: 20, paddingHorizontal: 16 }}
      >
          <View style={{justifyContent: 'center', alignItems: 'center'}}>
              <View style={styles.imageBgBox}>
                  <FastImage
                      source={globalConfigurableData?.event_about()}
                      style={{ width: 25, height: 25,}}
                  />
              </View>
              <FormTextLabel
                  labelStyles={{...globalFontStyle.appFontHeading, textAlign: 'center', color: globalConfigurableData.primaryTextColor1, paddingTop: 10}}
                  label={"Frequently Asked Questions"}
              />
          </View>
          {data && (
              <View style={{marginTop: 15}}>
                  {data.map((qaItem, i) => {
                      return (
                          <View key={i}>
                              <Text style={{...globalFontStyle.appFontSubTextBold, color: globalConfigurableData.primaryTextColor1, paddingVertical: 10}}>{qaItem?.q}</Text>
                              <Text style={styles.appMobValKey}>{qaItem?.a}</Text>
                          </View>
                      );
                  })}
              </View>
          )}
      </View>
  );
};

export default FAQ;

const styles = StyleSheet.create({
    imageBgBox: {
        backgroundColor: globalConfigurableData.secondaryTextColor1,
        width: 55,
        height: 55,
        borderRadius: 100,
        justifyContent: 'center',
        alignItems: 'center'
    },
    appMobValKey: {
        color: globalConfigurableData.secondaryTextColor1,
        ...globalFontStyle.appFontSubText,
        paddingBottom: 3,
        alignItems: "center",
    },
});
